import { apiClient } from "@/lib/api";
import { persistableGatekeeperPrecisions } from "@/lib/qualification-lifecycle/project-messages";
import { normalizeGatekeeperTranscript } from "@/lib/qualification-lifecycle/normalize-transcript";
import type { GatekeeperPrecisionPair, Message } from "@/types";

export async function persistGatekeeperPrecisionsToDatabase(input: {
  dustConversationId: string;
  dustMessageId: string | null | undefined;
  precisions: GatekeeperPrecisionPair[];
}): Promise<void> {
  const gatekeeperPrecisions = persistableGatekeeperPrecisions(
    input.precisions
  );
  if (!gatekeeperPrecisions.length || !input.dustMessageId) return;

  await apiClient.upsertGatekeeperPrecisions(input.dustConversationId, {
    dustMessageId: input.dustMessageId,
    gatekeeperPrecisions,
  });
}

export function applyGatekeeperPrecisionsFromDatabase(
  messages: Message[],
  items: {
    dustMessageId: string;
    gatekeeperPrecisions: GatekeeperPrecisionPair[];
  }[]
): Message[] {
  if (!items.length) return messages;
  return normalizeGatekeeperTranscript(messages, items);
}
